module.exports = __webpack_public_path__ + "static/background-a327396010a59ac787f72e8caf24508d.jpg";